import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
interface CommonScrollbarProps {
  children: React.ReactNode;
  height?: string | number;
}
const CommonScrollbar: React.FC<CommonScrollbarProps> = ({ children, height = "60vh" }) => {
  return (
    <SimpleBar style={{ height, overflowX: "hidden" }} className="pe-3 ps-2">
      {children}
    </SimpleBar>
  );
};

export default CommonScrollbar;
